import {AxiosInstance} from "axios";
import {PaginatedData} from "@/core/interfaces/api";
import {HospitalTimelineEntry} from "@/hospital/interfaces/hospital-timeline";

const ConsumerHospitalResource = (client: AxiosInstance) => {
    return {
        /**
         * Get the hospital timeline for a specific consumer.
         */
        consumerTimeline: async (consumerKey: string, page = 1, limit = 20): Promise<PaginatedData<HospitalTimelineEntry[]>> => {
            return client.get(`consumers/${consumerKey}/hospital-timeline`, {
                params: {page, limit}
            }).then(response => response.data);
        },

        /**
         * Send a message to the hospital for a specific consumer.
         */
        sendMessageToHospital: async (consumerKey: string, message: string, sharingIds: number[]): Promise<void> => {
            return client.post(`consumers/${consumerKey}/hospital-messages`, {
                content: message,
                sharing_ids: sharingIds
            }).then(response => response.data);
        }
    };
};

export default ConsumerHospitalResource;
